import BloodPressureTable from './BloodPressureTable'

export default BloodPressureTable
